import { render } from "./notifications-component.vue?vue&type=template&id=5e45489c"
const script = {}

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__